import { Text } from '@fly/core';
import classNames from 'classnames';

import { FlyCopyButton } from '../FlyCopyButton/FlyCopyButton';

export function FlyCodeCopy({
  code,
  label,
  className,
  highContrast = false,
  ...rest
}: {
  code: string;
  label?: string;
  className?: string;
  highContrast?: boolean;
}) {
  return (
    <div
      data-testid='fly-code-copy'
      className={classNames(
        'rounded-4 border-slateA-7 text-slate-11 flex items-center justify-between gap-fly-2 border px-fly-3 py-fly-2',
        className
      )}
    >
      <Text
        size='1'
        color='neutral'
        highContrast={highContrast}
        className='truncate'
      >
        {label || code}
      </Text>
      <FlyCopyButton
        {...rest}
        highContrast={highContrast}
        code={code}
        className='align-center flex'
        size={16}
        copyTimeoutMs={3000}
      />
    </div>
  );
}
